.card {
  border: 2px solid #dee2e6;
  border-radius: 0.75rem;
  padding: 0.75rem;
  cursor: pointer;
  background: white;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 160px;
  min-width: 120px;
  max-width: 220px;

  &:hover {
    border-color: #0d6efd;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
  }
}

.cardSelected {
  border-color: #0d6efd;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.25);
  background: #f0f6ff;
}

.image {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 0.5rem;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.imagePlaceholder {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 0.5rem;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
}

.title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #212529;
  text-overflow: ellipsis;
}

.visibilityRow {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  color: #6c757d;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.badge {
  font-size: 0.65rem;
  padding: 0.2rem 0.45rem;
  border-radius: 999px;
  font-weight: 500;
  background: #e2f0e8;
  color: #1a6335;
  border: 1px solid #b8ddc7;
  white-space: nowrap;
}

.badgeInactive {
  font-size: 0.65rem;
  padding: 0.2rem 0.45rem;
  border-radius: 999px;
  font-weight: 500;
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
  white-space: nowrap;
  text-decoration: line-through;
}
